import React from 'react';
import { makeStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import { Grid } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const useStyles = makeStyles({
    table: {
        minWidth: 340,
    },
    root: {
    },
    tableCell: {
        paddingRight: 4,
        paddingLeft: 5
    },
    // Mobile card styles
    mobileContainer: {
        display: 'none',
        '@media (max-width: 768px)': {
            display: 'block',
        },
    },
    desktopContainer: {
        display: 'block',
        '@media (max-width: 768px)': {
            display: 'none',
        },
    },
    mobileCard: {
        background: '#fff',
        borderRadius: '12px',
        padding: '16px',
        marginBottom: '12px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        border: '1px solid #f0f0f0',
        boxSizing: 'border-box',
    },
    cardHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        marginBottom: '12px',
        paddingBottom: '12px',
        borderBottom: '1px solid #f0f0f0',
    },
    userInfo: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    userIcon: {
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        backgroundColor: 'rgba(111, 41, 129, 0.1)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#6f2981',
    },
    userName: {
        fontSize: '15px',
        fontWeight: 600,
        color: '#333',
        margin: 0,
        wordBreak: 'break-word',
    },
    testName: {
        fontSize: '13px',
        color: '#666',
        margin: '4px 0 0 0',
        wordBreak: 'break-word',
    },
    srNo: {
        fontSize: '12px',
        color: '#999',
        backgroundColor: '#f5f5f5',
        padding: '4px 10px',
        borderRadius: '12px',
        fontWeight: 500,
    },
    cardBody: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '10px',
    },
    infoItem: {
        display: 'flex',
        flexDirection: 'column',
        gap: '2px',
    },
    infoLabel: {
        fontSize: '11px',
        color: '#999',
        textTransform: 'uppercase',
        fontWeight: 500,
    },
    infoValue: {
        fontSize: '13px',
        color: '#333',
        fontWeight: 500,
        wordBreak: 'break-word',
    },
    timeInfo: {
        gridColumn: 'span 2',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: '8px',
        paddingTop: '12px',
        borderTop: '1px solid #f0f0f0',
    },
    timeRemaining: {
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        color: '#6f2981',
        fontWeight: 600,
        fontSize: '14px',
    },
    lastUpdated: {
        fontSize: '12px',
        color: '#888',
    },
});
export default function CustomizedTables(props) {
    const classes = useStyles();
    const {_adminData,tableData,_setActiveUser} = props;

    const hasData = tableData && tableData.length > 0;

    const formatTimeRemaining = (seconds) => {
        if (seconds === "-" || seconds === undefined) return "-";
        const hrs = Math.trunc(Number(seconds) / 3600);
        const mins = Math.trunc(Number(seconds) % 3600 / 60);
        const secs = Math.trunc(Number(seconds) % 3600 % 60);
        return `${hrs}:${mins < 10 ? "0" : ""}${mins}:${secs < 10 ? "0" : ""}${secs}`;
    };

    const formatDate = (dateStr) => {
        if (dateStr === "-" || dateStr === undefined) return "-";
        const date = new Date(dateStr);
        return date.toLocaleDateString('en-GB', {day: 'numeric', month: 'short', year: 'numeric'}).replace(/ /g, '-') + " " + date.toLocaleTimeString([],{hour:'2-digit',minute:'2-digit',hour12:true});
    };

    const sortedData = hasData ? [...tableData].sort((item1, item2) => new Date(item2[1]['updatedAt']) - new Date(item1[1]['updatedAt'])) : [];

    return (
        <Grid item xs={12}>
            <Paper className={classes.root}>
                {hasData ? (
                <>
                {/* Mobile Card Layout */}
                <div className={classes.mobileContainer}>
                    {sortedData.map((item, index) => (
                        <div key={`mobile-${index}`} className={classes.mobileCard}>
                            <div className={classes.cardHeader}>
                                <div className={classes.userInfo}>
                                    <div className={classes.userIcon}>
                                        <PersonIcon fontSize="small" />
                                    </div>
                                    <div>
                                        <p className={classes.userName}>{item[1]['username']}</p>
                                        <p className={classes.testName}>{item[1]['testName']}</p>
                                    </div>
                                </div>
                                <span className={classes.srNo}>#{index + 1}</span>
                            </div>
                            <div className={classes.cardBody}>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>UserExam ID</span>
                                    <span className={classes.infoValue}>{item[1]['userExamId']}</span>
                                </div>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>Test ID</span>
                                    <span className={classes.infoValue}>{item[1]['testId']}</span>
                                </div>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>Browser</span>
                                    <span className={classes.infoValue}>{item[1]['browser']}</span>
                                </div>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>Device</span>
                                    <span className={classes.infoValue}>{item[1]['device']}</span>
                                </div>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>Questions</span>
                                    <span className={classes.infoValue}>{item[1]['totalQuestion']}</span>
                                </div>
                                <div className={classes.infoItem}>
                                    <span className={classes.infoLabel}>Answered</span>
                                    <span className={classes.infoValue}>{item[1]['answeredQuestionsCount']}</span>
                                </div>
                                <div className={classes.timeInfo}>
                                    <div className={classes.timeRemaining}>
                                        <AccessTimeIcon fontSize="small" />
                                        {formatTimeRemaining(item[1]['timeRemaining'])}
                                    </div>
                                    <span className={classes.lastUpdated}>{formatDate(item[1]['updatedAt'])}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Desktop Table Layout */}
                <div className={`listing_div ${classes.desktopContainer}`}>
                    <div className="list_head">
                        <p>
                            <span className="admin-srno" >Sr.No</span>
                            <span className="admin-name-ongoing" >Username</span>
                            <span className="admin-userexamid-ongoing" style={{ textAlign: "center" }}>UserExam Id</span>
                            <span className="admin-browser-ongoing" >Browser</span>
                            <span className="admin-device-ongoing" >Device</span>
                            <span className="admin-testid-ongoing" style={{ textAlign: "center" }}>Test Id</span>
                            <span className="admin-testname-ongoing" >Test Name</span>
                            <span className="admin-totalquestion-ongoing" style={{ textAlign: "center" }}>#Questions</span>
                            <span className="admin-answered-ongoing" style={{ textAlign: "center" }}>#Answered</span>
                            <span className="admin-timeremaining-ongoing" >Time Remaining</span>
                            <span className="admin-lastupdated-ongoing" >Last Updated</span>
                        </p>
                    </div>
                    {sortedData.map((item,index) => {
                        return (
                        <div key={`desktop-${index}`} className={index % 2 !== 0 ? "list_even list_name" : "list_odd list_name"}  >
                        <div className="list_detail_2">
                        <span className="admin-srno">{index + 1}</span>
                        <span  className="admin-name-ongoing">{item[1]['username']}</span>
                        <span  className="admin-userexamid-ongoing" style={{ textAlign: "center" }}>{item[1]['userExamId']}</span>
                        <span  className="admin-browser-ongoing">{item[1]['browser']}</span>
                        <span  className="admin-device-ongoing">{item[1]['device']}</span>
                        <span  className="admin-testid-ongoing" style={{ textAlign: "center" }}>{item[1]['testId']}</span>
                        <span  className="admin-testname-ongoing">{item[1]['testName']}</span>
                        <span  className="admin-totalquestion-ongoing" style={{ textAlign: "center" }}>{item[1]['totalQuestion']}</span>
                        <span  className="admin-answered-ongoing" style={{ textAlign: "center" }}>{item[1]['answeredQuestionsCount']}</span>
                        <span  className="admin-timeremaining-ongoing">{formatTimeRemaining(item[1]['timeRemaining'])}</span>
                        <span  className="admin-lastupdated-ongoing">{formatDate(item[1]['updatedAt'])}</span>
                        </div>
                        </div>
                        );
                    })}
                </div>
                </>
                ) : (
                <div style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "48px 24px",
                  textAlign: "center"
                }}>
                  <div style={{
                    width: "64px",
                    height: "64px",
                    borderRadius: "50%",
                    backgroundColor: "#f5f0f7",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    marginBottom: "16px"
                  }}>
                    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#7030a0" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                      <circle cx="9" cy="7" r="4"></circle>
                      <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                      <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                    </svg>
                  </div>
                  <h4 style={{
                    margin: "0 0 8px 0",
                    fontSize: "18px",
                    fontWeight: "600",
                    color: "#333"
                  }}>
                    No Users Found
                  </h4>
                  <p style={{
                    margin: "0",
                    fontSize: "14px",
                    color: "#666",
                    maxWidth: "300px"
                  }}>
                    No active users at this moment.
                  </p>
                </div>
                )}
            </Paper>
        </Grid>
    );
}